var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCssImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 91,
    viewBox: "0 0 78 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44643 80.5804L0 0H77.3571L70.9107 80.5804L38.6786 90.25L6.44643 80.5804Z",
    fill: "#1172B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9107 6.44641H38.6786V85.4152L64.4643 77.3571L70.9107 6.44641Z",
    fill: "#33AADD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9598 46.7366H17.7277L16.1161 35.4553L41.9018 27.3973H16.1161L14.5045 17.7277H64.4643L62.8527 29.0089L41.9018 37.0669H61.2411L58.0178 67.6875L38.6786 74.1339L19.3393 67.6875L17.7277 51.5714H27.3973L29.0089 59.6294L38.6786 62.8527L48.3482 59.6294L49.9598 46.7366Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssImg);
export default __webpack_public_path__ + "static/media/css-img.b6c0af184dfb809b102f247c8c37ca33.svg";
export { ForwardRef as ReactComponent };